"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TreeNode_1 = __importDefault(require("./TreeNode"));
var helper_1 = require("./helper");
var TreeContainer = /** @class */ (function (_super) {
    __extends(TreeContainer, _super);
    function TreeContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeContainer.prototype.render = function () {
        var _a = this.props, data = _a.data, Template = _a.Template, onTreeEvent = _a.onTreeEvent;
        return (react_1.default.createElement(TreeNode_1.default, { data: data, onUpdateData: this.onUpdateData.bind(this), onTreeEvent: onTreeEvent, Template: Template, onDelete: function () {
                console.log('trying to delete root node');
            }, onUpdateParent: function () {
                console.log('trying to update parent of root');
            } }));
    };
    TreeContainer.prototype.onUpdateData = function (path, node) {
        var _a = this.props, data = _a.data, onUpdateData = _a.onUpdateData;
        var result = helper_1.pathMerge(data, path, node);
        onUpdateData(result);
    };
    return TreeContainer;
}(react_1.Component));
exports.default = TreeContainer;
